



















import Vue, { PropOptions } from 'vue';
import { Integration } from '@/models';
import ButtonAction from '@/components/ButtonAction.vue';
import ModalCreateNewBot from '@/components/bots/ModalCreateNewBot.vue';

export default Vue.extend({
  components: { ButtonAction, ModalCreateNewBot },
  props: {
    bot: Object as PropOptions<Integration>,
  },
  data() {
    return {
      botInfos: this.bot,
      showCreate: false,
      loading: false,
    };
  },
  methods: {
    onShowDialog() {
      (this as any).showCreate = true;
    },
    onCloseDialog() {
      (this as any).showCreate = false;
    },
    async onSaveBot() {
      this.loading = true;
      this.onCloseDialog();
      try {
        await this.$store.dispatch('updateBot', this.bot);

        this.$store.commit('addSnackbar', {
          text: `Bot salvo com sucesso!`,
          color: 'success',
        });
      } catch (error) {
        this.$store.commit('addSnackbar', {
          text: `Erro ao salvar bot: ${error.message}`,
        });
      }
      this.loading = false;
    },
  },
  watch: {
    bot(val) {
      this.botInfos = val;
    },
  },
});
